<template>
<div class="topologymap-category-dynamic-menu">
  <div class="wrapper">
    <div class="more-show-btn" v-if="isEditMode" @click="onClickMoreButton">
      <span>더보기</span>
      <div class="caret-wrapper" :style="caretStyle">
        <div class="el-select__caret el-input__icon el-icon-arrow-up"></div>
      </div>
    </div>
    <div v-for="(item, index) in items" :key="item.key">
      <div :class="['row', (index % 2 === 1 ? 'map-help-column-bg' : '')]">
        <div class="column" v-for="(column, index) in item.columns" :key="index">
          <div :class="column.keyClass">
            <div
              v-for="key in column.keyItems"
              :key="key.subkey"
              :class="key.class"
              :style="key.style">
              <span v-if="!isEmpty(key.text)">{{ key.text }}</span>
            </div>
          </div>
          <div v-if="!isEmpty(column.subtext)" class="text" v-html="column.subtext"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as d3 from 'd3';
import Base from '@/mixins/topologymap/base';
import { isEmpty } from '@/utils/basic';
import MapConst from '@/constants/topologymap';

export default {
  name: 'WCategoryDynamicMenu',
  components: {},
  mixins: [Base],
  data() {
    return {
      isEmpty,
      extendedStatus: false,
      hotkeyItems: [
        {
          key: '1',
          columns: [
            {
              keyClass: 'keys',
              keyItems: [
                { key: '1-1-1', class: 'map-help-key-back' },
                { key: '1-1-2', class: 'operator', text: '/' },
                { key: '1-1-3', class: 'map-help-key-del' },
              ],
              subtext: '오브젝트 삭제',
            },
            {
              keyClass: 'keys',
              keyItems: [
                { key: '1-2-1', class: 'map-help-key-ctrl' },
                { key: '1-2-2', class: 'operator', text: '+' },
                { key: '1-2-3', class: 'map-help-key-c' },
              ],
              subtext: '오브젝트 복사',
            },
          ],
        },
        {
          key: '2',
          columns: [
            {
              keyClass: 'keys',
              keyItems: [
                { key: '2-1-1', class: 'map-help-key-ctrl' },
                { key: '2-1-2', class: 'operator', text: '+' },
                { key: '2-1-3', class: 'map-help-key-a' },
              ],
              subtext: '오브젝트 전체선택',
            },
            {
              keyClass: 'keys',
              keyItems: [
                { key: '2-2-1', class: 'map-help-key-ctrl' },
                { key: '2-2-2', class: 'operator', text: '+' },
                { key: '2-2-3', class: 'map-help-key-v' },
              ],
              subtext: '오브젝트 붙여넣기',
            },
          ],
        },
        {
          key: '3',
          columns: [
            {
              keyClass: 'keys',
              keyItems: [
                { key: '3-1-1', class: 'map-help-key-arrows' },
              ],
              subtext: '오브젝트 이동',
            },
            {
              keyClass: 'keys',
              keyItems: [
                { key: '3-2-1', class: 'map-help-key-ctrl' },
                { key: '3-2-2', class: 'operator', text: '+' },
                { key: '3-2-3', class: 'map-help-key-x' },
              ],
              subtext: '오브젝트 잘라내기',
            },
          ],
        },
        {
          key: '4',
          columns: [
            {
              keyClass: 'keys',
              keyItems: [
                { key: '4-1-1', class: 'map-help-key-l' },
              ],
              subtext: '선 연결',
            },
            {
              keyClass: 'keys',
              keyItems: [
                { key: '4-2-1', class: 'map-help-key-ctrl' },
                { key: '4-2-2', class: 'operator', text: '+' },
                { key: '4-2-3', class: 'map-help-key-z' },
              ],
              subtext: '되돌리기',
            },
          ],
        },
        {
          key: '5',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '5-1-1', class: 'map-help-key-shift' },
                { key: '5-1-2', class: 'operator', text: '+' },
                { key: '5-1-3', class: 'map-help-key-mouse-left' },
                { key: '5-1-4', class: 'text', text: '(드래그)' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '시작점에 위치한 대상 ~ <br>끝점에 위치한 대상간 선 연결',
            },
          ],
        },
        {
          key: '6',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '6-1-1', class: 'map-help-key-space' },
                { key: '6-1-2', class: 'operator', text: '+' },
                { key: '6-1-3', class: 'map-help-key-mouse-left' },
                { key: '6-1-4', class: 'text', text: '(드래그)' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '(기본 편집모드) 화면 이동',
            },
          ],
        },
        {
          key: '7',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '7-1-1', class: 'map-help-key-mouse-right' },
                { key: '7-1-2', class: 'operator', text: '+', style: 'margin: 5px;' },
                { key: '7-1-3', class: 'map-help-key-mouse-left' },
                { key: '7-1-4', class: 'text', text: '(드래그)' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '(이동 모드) 다중 대상 선택',
            },
          ],
        },
      ],
      userActionItems: [
        {
          key: '1',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '2-1-1', class: 'text', text: '(오브젝트) 마우스 오버' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '상세 정보 확인',
            },
          ],
        },
        {
          key: '2',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '2-1-1', class: 'text', text: '(오브젝트)' },
                { key: '2-1-2', class: 'map-help-key-mouse-left' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '이벤트 확인',
            },
          ],
        },
        {
          key: '3',
          columns: [
            {
              keyClass: 'keys-only',
              keyItems: [
                { key: '3-1-1', class: 'text', text: '(관리대상)' },
                { key: '3-1-2', class: 'map-help-key-mouse-right' },
              ],
            },
            {
              keyClass: 'text',
              subtext: '옵션 설정',
            },
          ],
        },
      ],
    };
  },
  computed: {
    items() {
      return this.isEditMode ? this.hotkeyItems : this.userActionItems;
    },
    caretStyle() {
      return this.extendedStatus ? 'transform: rotate(180deg)' : '';
    },
  },
  methods: {
    onClickMoreButton(paramBoolean) {
      if (paramBoolean === false || this.extendedStatus) {
        this.extendedStatus = false;
        d3.select(this.$parent.$el).select(function anonymousFunc() { return this.parentNode; })
          .transition()
          .style('height', '190px');
      } else {
        this.extendedStatus = true;
        d3.select(this.$parent.$el).select(function anonymousFunc() { return this.parentNode; })
          .transition()
          .style('height', '311px');
      }
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.$emit('update:thirdMenuTitle', MapConst.HELP.MENU_TITLE_AT_EDIT);
    } else {
      this.$emit('update:thirdMenuTitle', MapConst.HELP.MENU_TITLE_AT_MONITORING);
    }
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/_variable.scss';
.topologymap-category-dynamic-menu {
  $contents-keys-width: 80px;
  $contents-keysonly-width: $contents-keys-width + 65px;

  .wrapper {
    .row {
      height: 38px;
      padding: 5px;
      display: flex;
      flex-direction: row;
      .column {
        height: 100%;
        display: flex;
        align-items: center;
        flex: 1;
        .keys {
          width: $contents-keys-width;
          display: flex;
          justify-content: center;
          align-items: center;
          .operator {
            font-size: 15px;
            font-weight: bold;
            margin: 2px;
          }
          .text {
            font-size: 10px;
            font-weight: bold;
            margin: 2px;
          }
        }
        .keys-only {
          @extend .keys;
          width: $contents-keysonly-width;
        }
        .text {
          font-family: 'Malgun Gothic';
          font-size: 11px;
          color: $evilgray;
        }
      }
    }
    .more-show-btn {
      position: absolute;
      right: 90px;
      top: 7px;
      width: 53px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      .caret-wrapper {
        margin-left: -5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/CategoryDynamicMenu.vue